/**
 * Defines the Certificates View that shows my AWS certificates.
 */
import React, { useEffect } from "react";
import { motion } from "framer-motion";
import "./certificates.css";

export const CertificatesView = () => {
  const certificateIds = [
    "06f84888-bbd5-434a-8982-cce185a4963e",
    // "7bb2665b-958f-4a0c-93dd-d82c7eb478e2",
    "6d40cf43-17a9-49e5-a893-2c7c902d53c7",
    "ba5c2dec-94e9-491e-a1e2-961d1c4f3ffa",
    "724f2d5a-b1f4-45de-96d7-abd38378a21c",
    "639b2ed6-f799-40ba-b033-3608383c2c5e",
    "f7dbfaa2-3a86-483e-ac2d-71204ab3d519",
  ];

  useEffect(() => {
    const script = document.createElement("script");

    script.src = "https://cdn.credly.com/assets/utilities/embed.js";
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div id="certificates" className="text-center">
      <div className="container">
        <motion.div
          className="certificates-header"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: { opacity: 0, y: -20 },
            visible: {
              opacity: 1,
              y: 0,
              transition: { duration: 0.6 },
            },
          }}
        >
          <h2 className="certificates-title">AWS Certifications</h2>
          <p className="certificates-subtitle">
            Our team holds multiple AWS certifications, demonstrating our
            expertise in cloud solutions
          </p>
        </motion.div>

        <div className="row certificates-grid">
          {/* certificates */}
          {certificateIds.map((d, i) => (
            <motion.div
              key={`${d}-${i}`}
              className="col-md-4 col-sm-4"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={{
                hidden: { opacity: 0, y: 30 },
                visible: {
                  opacity: 1,
                  y: 0,
                  transition: { duration: 0.6, delay: i * 0.2 },
                },
              }}
            >
              <div
                className="service-desc"
                data-share-badge-id={`${d}`}
                data-share-badge-host="https://www.credly.com"
                data-iframe-width="100%"
                data-iframe-height="100%"
              ></div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};
